import type { ReactNode } from 'react';

interface PageTitleProps {
  title: string;
  actions?: ReactNode;
  subtitle?: string;
}

export const PageTitle = ({ actions, subtitle, title }: PageTitleProps) => {
  return (
    <div className="mgo-split mgo-align-start" style={{ marginBottom: 'var(--mgo-space-60)' }}>
      <div style={{ minWidth: 0 }}>
        <h1 className="mgo-text-l mgo-weight-strong" style={{ margin: 0 }}>{title}</h1>
        {subtitle && <p className="mgo-text-s mgo-color-muted" style={{ margin: 0, marginTop: 'var(--mgo-space-20)', maxWidth: '48rem' }}>{subtitle}</p>}
      </div>
      {actions && <div className="mgo-cluster mgo-gap-s" style={{ flexShrink: 0 }}>{actions}</div>}
    </div>
  );
}
